/* Customall owns its buttons. Decorate attributes only; never change app text or events. */
if (!customElements.get('inkybox-variant-best-seller')) {
  customElements.define('inkybox-variant-best-seller', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.mount();
      });
    }

    mount() {
      this.root = this.closest('product-info')?.querySelector('.product__info-container');
      if (!this.root) return;
      this.observer = new MutationObserver(() => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.decorate();
        });
      });
      this.observer.observe(this.root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-ctm-option-name', 'data-ctm-value'],
      });
      this.decorate();
    }

    decorate() {
      this.root.querySelectorAll('#personalized-form [data-ctm-option-name]').forEach(option => {
        const matchesName = option.dataset.ctmOptionName === this.dataset.optionName;
        option.querySelectorAll('.buttons-group').forEach(group => {
          let hasBadge = false;
          group.querySelectorAll('button[data-ctm-value]').forEach(button => {
            const matches = matchesName && button.dataset.ctmValue === this.dataset.optionValue;
            button.toggleAttribute('data-inkybox-best-seller', matches);
            hasBadge ||= matches;
          });
          group.toggleAttribute('data-inkybox-best-seller-group', hasBadge);
        });
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
